import { Lovetab } from './icons/Lovetab';
import './LoadingOverlay.scss';

export const LoadingOverlay = () => {
  return (
    <div className="loading-overlay">
      <Lovetab width="7em" height="7em" className="loading-overlay__loader" />
    </div>
  );
};
